// Streaming linear resampler: keeps the unread tail between blocks so the read position stays continuous
export class StreamingResampler {
    private leftover = new Float32Array(0);
    private position = 0;

    constructor(
        private readonly sourceRate: number,
        private readonly targetRate: number,
    ) {}

    public process(block: Float32Array): Float32Array {
        if (this.sourceRate === this.targetRate) {
            return block;
        }

        const input = new Float32Array(this.leftover.length + block.length);
        input.set(this.leftover, 0);
        input.set(block, this.leftover.length);

        const step = this.sourceRate / this.targetRate;
        const outputLength = Math.max(0, Math.floor((input.length - 1 - this.position) / step) + 1);
        const output = new Float32Array(outputLength);

        let position = this.position;
        for (let i = 0; i < outputLength; i++) {
            const lower = Math.floor(position);
            const upper = Math.min(lower + 1, input.length - 1);
            const fraction = position - lower;
            output[i] = input[lower] * (1 - fraction) + input[upper] * fraction;
            position += step;
        }

        const keepFrom = Math.floor(position);
        this.leftover = input.slice(keepFrom);
        this.position = position - keepFrom;

        return output;
    }
}
